// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__Qdof5","content":"LayoutSettings_content__1fxXf"};